/**
 * Device detection utilities for handling mobile-specific behavior
 * 
 * Note: These utilities use user agent string parsing rather than feature detection
 * because the specific requirement is to detect iPhone/mobile devices for OAuth flows.
 * Feature detection (e.g., touch support, screen size) cannot reliably distinguish
 * between desktop browsers with touch screens and actual mobile devices.
 * User agent sniffing is the standard approach for this use case.
 */

/**
 * Detects if the current device is a mobile device (iPhone, iPad, iPod, Android)
 * @returns true if mobile device detected, false otherwise
 */
export const isMobileDevice = (): boolean => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

/**
 * Detects if the current device is an iOS device (iPhone, iPad, iPod)
 * @returns true if iOS device detected, false otherwise
 */
export const isIOSDevice = (): boolean => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

/**
 * Detects if the current device is an Android device
 * @returns true if Android device detected, false otherwise
 */
export const isAndroidDevice = (): boolean => {
  return /Android/i.test(navigator.userAgent);
};
